(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiMyTrainingCourseLog', taiMyTrainingCourseLog);

    function taiMyTrainingCourseLog() {
        var directive = {
            bindToController: true,
            controller: taiMyTrainingCourseLogController,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/taiMyTraining.courseLog.html',
            scope: {
                isFocus: '=',
                translatePool: '=',
            }
        };
        return directive;
    }
    /* @ngInject */
    function taiMyTrainingCourseLogController(trainingInnerService, $q, $scope, modalService) {
        var vm = this;
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        vm.translatePool = $scope.$parent.vm.data.translatePool;
        onInit();
        function onInit() {
            vm.isMobile=modalService.isMobile();
            vm.openYearSelector = openYearSelector;
            //vm.openTime = openTime;
            vm.yearChange = yearChange;
            vm.statusConvert = statusConvert;
            vm.method = methodList(); //找機會要把上面的設定移到這裡
            //======
            vm.data = dataInit();
            vm.view = viewInit();
            //======
            $scope.$watch('vm.data.courseLogFilter.length', function(newValue, oldValue) {
                if (newValue === oldValue) { return; }
                if (!newValue) { newValue = 0; }
                vm.view.courseLogEmpty = newValue < 1;
            });
            $scope.$watch('vm.isFocus', function(newValue) {
                if (newValue === true) {
                    logicInit();
                }
            });
        }

        function dataInit() {
            var result = {
                courseLogSource: [],
                courseLog: [],
                courseLogFilter: []
            };

            return result;
        }

        function viewInit() {
            var result = {
                courseLogEmpty: false, //.........查無資料判定
                isInited: false, //............是否被初始化過
                pageLoaded: false, //..........頁面讀取完畢
                pageLoading: false, //.........頁面讀取中
            };
            return result;
        }

        function methodList() {
            var result = {
                filterSessionTimeByYear: filterSessionTimeByYear,
            };
            return result;
        }

        function logicInit() {
            vm.view.isInited = true;
            vm.view.pageLoaded = false;
            vm.view.pageLoading = true;
            //======
            return trainingInnerService.getCourseLog(sessionStorage.getItem("userLang"))
                .then(function(courseLog) {
                    //取代<br>
                    _.forEach(courseLog,function(data){
                        //console.log('sTime:',data.sessionTime);
                        data.sessionTime=data.sessionTime.replace(/\<br\>/ig,' ');
                        //console.log('data:',data.sessionTime);
                    });
                    //console.log('courseLog:', courseLog);
                    vm.data.courseLogSource = courseLog;
                    vm.years = trainingInnerService.getYears(2011);
                    vm.year = vm.years[0];
                    getCourseLog();
                    return true;
                })
                .then(function() {
                    vm.view.pageLoaded = true;
                    vm.view.pageLoading = false;
                });
        }


        function filterSessionTimeByYear(year) {
            return _.filter(vm.data.courseLogSource, function(o) {
                return o.sessionTime.indexOf(year) !== -1;
            });
        }

        function getCourseLog() {
            vm.data.courseLog = vm.method.filterSessionTimeByYear(vm.year);
            vm.view.courseLogEmpty = vm.data.courseLog.length < 1;
        }

        function yearChange(year) {
            vm.year = year;
            getCourseLog();
        }

        function statusConvert(statusCode) {
            if (!statusCode && statusCode !== 0) { return ''; }
            switch (statusCode + '') {
                case '-1':
                    return vm.translatePool.tsunPassStatusValueNotCourage;
                case '0':
                    return vm.translatePool.tsunPassStatusValueNA;
                case '1':
                    return vm.translatePool.tsunPassStatusValueExemption;
                case '2':
                    return vm.translatePool.tsunPassStatusValueOK;
                case '3':
                    return vm.translatePool.tsunPassStatusValueNotOK;
                default:
                    return '';
            }
        }

        function openYearSelector() {
            var result = modalService.openOptionSelector(vm.years, 'yrSelect',false);
            //這個則是接收傳回來的值
            result.result.then(function(data) {
                vm.year = data;
                getCourseLog();
            });

        }
    }
})();